import { render, staticRenderFns } from "./SalaryList.vue?vue&type=template&id=e0008520&"
import script from "./SalaryList.vue?vue&type=script&lang=js&"
export * from "./SalaryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports